<template>
    <div class="c-datepicker-wrapper">
        <div class="c-datepicker-wrapper-fit">
            <datepicker class="c-datepicker" v-model="date" :inline="true" :language="datePickerLanguage"
                        :disabled-dates="disabledDates" :monday-first="true" :full-month-name="true"
                        @selectedDisabled="selectedDisabled" @selected="$emit('selected', $event)"
            ></datepicker>
            <custom-date-picker-disabled-message v-model="showDisabledMsg"></custom-date-picker-disabled-message>
        </div>
    </div>
</template>

<script>
    import Datepicker from './vuejs-datepicker-custom/components/Datepicker';
    import es from './vuejs-datepicker-custom/locale/translations/es';
    import CustomDatePickerDisabledMessage from "./CustomDatePickerDisabledMessage";

    export default {
        name: "CustomDatePicker",
        components: {
            CustomDatePickerDisabledMessage,
            Datepicker
        },
        props: {
            value: {},
            blockTo: {
                type: Date,
                default: () => moment().toDate()
            }
        },
        data() {
            return {
                dateAux: null,
                datePickerLanguage: es,
                showDisabledMsg: false,
            }
        },
        computed: {
            dateFormatted() {
                return moment(this.date).format('YYYY-MM-DD');
            },
            date: {
                get() {
                    return this.dateAux;
                },
                set(value) {
                    let fix = this.forceWeekDay(value);
                    if (fix < this.blockToDateWeekRestriction) {
                        fix = this.blockToDateWeekRestriction;
                    }
                    this.dateAux = fix;
                }
            },
            disabledDates() {
                let blockTo = moment(this.blockToDateWeekRestriction).toDate();
                return {
                    to: blockTo
                }
            },
            blockToDateWeekRestriction() {
                let weekDayDelivery = window.custom.params.week_day_delivery;
                let blockToDate = this.blockTo;
                if (moment(blockToDate).isoWeekday() >= weekDayDelivery) {
                    blockToDate = moment(blockToDate).add(1, 'week').toDate();
                }
                blockToDate = moment(blockToDate).isoWeekday(1).toDate();
                return blockToDate;
            }
        },
        watch: {
            value(newVal) {
                this.date = newVal;
            },
            dateAux() {
                this.dateFormattedChanged();
            }
        },
        methods: {
            forceWeekDay(value) {
                let isoWeekDay = window.custom.params.week_day_delivery;
                if (!value) {
                    value = new Date();
                }
                let forced = moment(value).isoWeekday(isoWeekDay).toDate();
                forced.setHours(0);
                forced.setMinutes(0);
                forced.setSeconds(0);
                forced.setMilliseconds(0);
                let blockTo = moment(this.blockTo).toDate();
                blockTo.setHours(0);
                blockTo.setMinutes(0);
                blockTo.setSeconds(0);
                blockTo.setMilliseconds(0);
                if (forced <= this.blockTo) {
                    forced = moment(value).add(1, 'week').isoWeekday(isoWeekDay).toDate();
                }
                return forced;
            },
            dateFormattedChanged() {
                this.$emit('input', this.dateFormatted);
            },
            selectedDisabled() {
                this.showDisabledMsg = true;
            },
            closeDisabledMsg() {
                this.showDisabledMsg = false;
            }
        },
        created() {
            this.datePickerLanguage.days = [
                "do", "lu", "ma", "mi", "ju", "vi", "sa"
            ]
            this.date = this.value;
            this.dateFormattedChanged();
        }
    }
</script>

<style scoped>

    .c-datepicker-wrapper {
        width: fit-content;
        margin: auto;
    }

    .c-datepicker-wrapper-fit {
        position: relative;
    }

    @media (min-width: 575px) {

        .c-datepicker-wrapper {
            border: 1px solid #c7c7c7;
            border-radius: 0.2rem;
            /*-webkit-box-shadow: 0 0 10px #c7c7c7;*/
            /*box-shadow: 0 0 10px #c7c7c7;*/
            padding: 1rem;
        }

    }


</style>

<style>
</style>
